export const getFilesFromClipboard = (clipboardEvent) => Array.from(clipboardEvent.clipboardData.items).reduce((acc, item) => {
  if (item.kind === 'file') {
    acc.push(item.getAsFile());
  }

  return acc;
}, []);
